import { Layer, Placeholder, Map, MapType } from '@/@types/graphql';
import { MAP_URL } from '@/constants';
import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class'
import * as AUDIOGUIDE from '@/@next/store/audioguide/types'

export interface FiberMapQueries {
  [key: string]: string;
}

@Component({ name: 'fiber-map-mixin' })
export default class FiberMap extends Vue {

  @Action(AUDIOGUIDE.SET_PLAYLIST) setAudioguidePlaylist!: any
  @Action(AUDIOGUIDE.SET_STATUS) setAudioguideStatus!: any
  @Action(AUDIOGUIDE.SET_POI) setAudioguidePoi!: any
  @Getter(AUDIOGUIDE.GET_STATUS) audioguideStatus!: boolean
  
  goTo (target: any) {
    // console.log(target, JSON.stringify(target))
    switch (target.type) {
      case 'pointOfInterest':
        return this.$router.push({
          name: 'single-poi',
          params: { uuid: target.id },
          query: target.contextCollection
            ? { collection: target.contextCollection }
            : {}
        });
      case 'collection':
        this.$router.push({
          name: 'single-collection',
          params: { uuid: target.id }
        });
      case 'audioGuideTracks':
        if (target.audioGuideTracks.length) {
          console.log('UPDATE audioGuideTracks, tracks', target.audioGuideTracks)
          console.log('UPDATE audioGuideTracks, poi', target.pointOfInterest)
          this.setAudioguidePlaylist([...target.audioGuideTracks]).then(() => {
            this.setAudioguidePoi(target.pointOfInterest)
            this.setAudioguideStatus(true)
          })
        }
        break;
      case 'url':
        const urlRegex = /^https?:\/\/(?:[\w-]+\.)+(?!\/)(?:[\w]{2,}\/?)+(?:\?[\w-]+=[\w-]+(?:&[\w-]+=[\w-]+)*)?(?:#[\w-]+)?$/
        if (!target.url || target.url.length < 3) return console.warn('Invalid URL ', target.url) // Invalid URL
        if (!urlRegex.test(target.url)) return this.$router.push(target.url) // URL local, on utilise le router
        return window.open(target.url, target.openSelfTab ? '_self' : '_blank')
      default:
        console.warn('Map go To target undefined', target, JSON.stringify(target));
        break;
    }
  }

  initCallbackMethods () {
    if (!window) return;
    window.addEventListener('message', (event) => {
      console.log('event', event)
      // checks message comes from map url
      if (event.origin !== MAP_URL) return console.warn('Invalid message from invalid URL :', event.origin)
      if (event.data) this.goTo(event.data)
    });
  }

  redirectToMap (queries: FiberMapQueries = {}) {
    if (!MAP_URL) return;
    this.$router.push({ name: 'fiber-map', query: queries });
  }

  showPlaceholder ({ id, layer }: Placeholder) {
    return this.redirectToMap({
      placeholderId: id,
      mapType: layer?.map?.type || MapType.Threejs,
    });
  }

  showLayer (layer: Layer | null = null) {
    if (!layer) return this.redirectToMap();
    return this.redirectToMap({ layerId: layer.id });
  }

  showMap (map: Map | null = null) {
    if (!map) return this.redirectToMap();
    return this.redirectToMap({ mapId: map.id });
  }
}
